import React from "react";
import { Route, Redirect } from "react-router-dom";
import GeneralUtils from "GeneralUtils";

const ProtectedRoute = ({ component: Component, ...rest }: any) => (
  <Route
    {...rest}
    render={(props) => {
      const token = GeneralUtils.getCookieValue("AUTH_TOKEN");
      return token ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={`/login?redirect=${encodeURIComponent(props.location.pathname)}`}
        />
      );
    }}
  />
);

export default ProtectedRoute;
